import { Component, OnChanges, SimpleChanges, inject, input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ICONS, IconName } from './icon-map';

@Component({
  selector: 'dc-icon',
  template: `
    <span
      [innerHTML]="sanitizedIcon"
      [style.display]="'inline-flex'"
      [style.alignItems]="'center'"
      [style.justifyContent]="'center'"
      [style.width.px]="size()"
      [style.height.px]="size()"
      [style.color]="color()"></span>
  `,
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
        line-height: 0;
      }
      span {
        line-height: 0;
      }
      :host ::ng-deep svg {
        width: 100%;
        height: 100%;
      }
    `,
  ],
  standalone: true,
})
export class IconsComponent implements OnChanges {
  private sanitizer = inject(DomSanitizer);

  readonly name = input.required<IconName>();
  readonly size = input<number>(14);
  readonly color = input<string>('currentColor');

  sanitizedIcon: SafeHtml;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['name']) {
      const svg = ICONS[this.name()] || '';
      this.sanitizedIcon = this.sanitizer.bypassSecurityTrustHtml(svg);
    }
  }
}
